import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD...",
  authDomain: "csri-15147.firebaseapp.com",
  projectId: "csri-15147",
  storageBucket: "csri-15147.firebasestorage.app",
  messagingSenderId: "925092669398",
  appId: "1:925092669398:web:2ffb600370aed0cd6b6677",
  measurementId: "G-BM2418QRRL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// THIS LINE IS THE FIX: Add 'export' at the beginning
export const db = getFirestore(app);